import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { jobTraceIdResponseSchema } from '../schemas/job-trace-id-response.schema';

/**
 * Remove all filtered assets based on fleet info criteria.
 * @returns The job trace ID
 */
export function deleteBulkAssetDelete(
  this: unknown,
  params: UserPagedCollectionParams,
  assetIds: string[]
) {
  const body =
    assetIds.length > 0
      ? JSON.stringify({
          assetIds,
        })
      : undefined;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).bulkAssetDeleteUrl()}?${params.urlParams}`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body,
        }
      )
    )
  ).pipe(selectData(jobTraceIdResponseSchema));
}
